import { Injectable } from '@angular/core';
import { CountryStore } from './country.store';
import { Country } from './models/country-model';
import { tap, mapTo } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { CountryQuery } from './country.query';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CountryService {

  constructor(private countryStore: CountryStore,
              private api: ApiService,
              private countryQuery: CountryQuery) {
  }

  fetchCountries() {
    const request$ = this.api.get<Country>('country/countries-with-regions').pipe(
      tap(a => {
        this.countryStore.set(a);
      }),
      mapTo(null)
    );
    return this.countryQuery.getHasCache() ? of(null) : request$;
  }
}
